<app-modal [open]="active" [name]="'bid-submitted'" (close)="closeDialog()">
  <div modal-header>Bid Submitted!</div>
  <div modal-body>
    The bid has been submitted and can be viewed from the
    <strong>Pending</strong> tab.
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    routerLink="/proposals"
    routerLinkActive="router-link-active"
    data-testid="bid-submitted-view-pending"
    (click)="closeDialog()"
  >
    View Pending
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="bid-submitted-close"
    (click)="closeDialog()"
  >
    Back
  </button>
</app-modal>
